import WithRender from "../../templates/containers/packingOptionsContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPackingOptions"])
  },
  props: ["hideContainer"]
});
